import React, { Component } from 'react'
import moment from 'moment'
import Toggle from 'components/controls/toggle'

import { 
	forIn,
	forEachRight
} from 'lodash'

import { doSort } from 'utils'

import DoughnutChart from 'components/charts/doughnut-chart'
import WeekNav from 'components/week-nav/week-nav'

import {
	formatByTimeZone,
	getPrimaryColumnValue,
} from 'utils'

export default class SinglePersonHoursPie extends Component {
	state = {
		pageIndex: 0, // counts backwards from today
		paginateType: 'week',
		dataTypeIndex: 0
	}

	toggleOptions = [
		{
			name: 'Weekly'
		},
		{
			name: 'Monthly'
		}
	]

	isDataFake = false

	getCurrentDates = _ => {
		const {
			pageIndex,
			paginateType
		} = this.state

		const start = moment().startOf(paginateType).subtract(pageIndex, paginateType)
		let end = moment(start).add(1, paginateType).subtract(1, 'day')

		const today = moment().startOf('day')

		// we'll ignore this for now.
		if(end.isAfter(today) && false){
			end = today
		}

		return {
			start,
			end
		}
	}

	getPaginatedSessionData = _ => {
		const {
			allSessions,
			allTasks,
			allProjects,
			allMilestones,
			userData,
		} = this.props

		const {
			dataTypeIndex
		} = this.state

		const relevantProjects = {}

		const dates = this.getCurrentDates()
		const endDate = moment(dates.end).add(1, 'day')

		if(dataTypeIndex){
			userData.tasks && userData.tasks.forEach(taskId => {
				const task = allTasks[taskId]

				if(!task || !task.estimated_minutes){
					return
				}

				const milestone = allMilestones[task.milestone_id]

				if(!milestone){
					return
				}

				const project = allProjects[milestone.project_id]

				if(!project){
					return
				}

				const taskDates = getPrimaryColumnValue('date', task, project)

				if(taskDates && taskDates.end){
					const dueMoment = formatByTimeZone(taskDates.end, null, true)

					if(dueMoment.isAfter(dates.start) && dueMoment.isBefore(endDate)){
						const totalSeconds = task.estimated_minutes * 60
						const totalHours = Math.round((totalSeconds/3600) * 100) / 100

						if(relevantProjects[project.id]){
							relevantProjects[project.id].hours += totalHours
							relevantProjects[project.id].seconds += totalSeconds
						}else{
							relevantProjects[project.id] = {
								hours: totalHours,
								seconds: totalSeconds
							}
						}
					}
				}
			})
		}else{
			userData.sessions && userData.sessions.forEach(sessionId => {
				const session = allSessions[sessionId]
				if(!session){
					return 
				}

				const createdMoment = formatByTimeZone(session.created_at, null, true)

				if(createdMoment.isAfter(dates.start) && createdMoment.isBefore(endDate)){
					const totalSeconds = formatByTimeZone(session.stopped_at, null, true).diff(createdMoment,'seconds')
					const totalHours = Math.round((totalSeconds/3600) * 100) / 100

					if(relevantProjects[session.project_id]){
						relevantProjects[session.project_id].hours += totalHours
						relevantProjects[session.project_id].seconds += totalSeconds
					}else{
						relevantProjects[session.project_id] = {
							hours: totalHours,
							seconds: totalSeconds
						}
					}
				}
			})
		}

		forIn(relevantProjects, (project, projectId) => {
			relevantProjects[projectId].projectId = parseInt(projectId)

			const projectHours = (Math.round(relevantProjects[projectId].hours * 100)/100)

			// I have zero idea why I need to do this here...
			relevantProjects[projectId].hours = projectHours
		})

		return relevantProjects
	}

	getDaysInMonth = _ => {
		const dates = this.getCurrentDates()
		const days = dates.end.diff(dates.start, 'days') + 1

		return days
	}
	
	generateDoughnutData = sessionData => {
		const {
			userData,
			accountData,
			allProjects
		} = this.props

		const {
			paginateType
		} = this.state

		const response = {
			backgroundColor: [],
			hoverBackgroundColor: [],
			data: [],
			borderWidth: 0,
		}

		const labelData = []

		let hoursWorked = null
		const hoursWorkedPerWeek = (userData.hours_worked && userData.hours_worked[accountData.id]) ? userData.hours_worked[accountData.id] : 38

		if(paginateType == 'week'){
			hoursWorked = hoursWorkedPerWeek
		}else{
			hoursWorked = Math.round(((hoursWorkedPerWeek * 52)/365) * this.getDaysInMonth())
		}

		let hoursAllocated = 0

		const sessionDataArray = doSort(Object.values(sessionData), 'number', 'hours', true)

		sessionDataArray.forEach(project => {
			const projectObject = allProjects[project.projectId]

			if(!projectObject){
				return
			}

			hoursAllocated += project.hours
			response.data.push(project.hours)
			labelData.push(projectObject.name)
		})

		this.isDataFake = false

		if(!hoursAllocated){
			this.isDataFake = true
			response.data = paginateType == 'week' ? [10, 9, 5] : [42, 33, 21]

			response.data.forEach(fakeHours => {
				hoursAllocated += fakeHours
			})
		}

		if(hoursAllocated < hoursWorked){
			response.lastAsEmpty = true
			response.data.push((hoursWorked - hoursAllocated))
			labelData.push('Untracked')
		}

		return {
			chartData: response,
			labelData,
			totalTracked: hoursAllocated,
			totalWorked: hoursWorked,
		}
	}

	toggleState = _ => {
		this.setState({
			paginateType: this.state.paginateType == 'week' ? 'month' : 'week'
		})
	}

	changeDay = (type, canChange) => {
		if(!canChange){
			return 
		}

		const currentPageIndex = this.state.pageIndex
		let newPageIndex = null

		switch(type){
			case 'prev':
				newPageIndex = currentPageIndex + 1
				break
			case 'next':
				newPageIndex = currentPageIndex - 1
				break
			case 'today':
				newPageIndex = 0
				break
		}

		this.setState({
			pageIndex: newPageIndex
		})
	}

	canChange = _ => {
		const {
			userData,
			allSessions,
			allTasks,
			allMilestones,
			allProjects
		} = this.props

		let canGoBack = true
		let canGoForward = true

		let earliestDate = moment()
		let latestDate = moment()

		if(userData.sessions){
			userData.sessions.sort()

			let hasFoundEarliestSession = false

			userData.sessions.forEach(sessionId => {
				const sessionObject = allSessions[sessionId]

				if(sessionObject){
					const sessionDate = formatByTimeZone(sessionObject.created_at, null, true)	

					if(!hasFoundEarliestSession){
						hasFoundEarliestSession = true
						earliestDate = sessionDate
					}

					latestDate = sessionDate
				}
			})
		}
		
		if(userData.tasks){
			userData.tasks.forEach(taskId => {
				const task = allTasks[taskId]

				if(!task || !task.estimated_minutes){
					return
				}

				const milestone = allMilestones[task.milestone_id]

				if(!milestone){
					return
				}

				const project = allProjects[milestone.project_id]

				if(!project){
					return
				}

				const taskDates = getPrimaryColumnValue('date', task, project)

				if(taskDates.start){
					const startMoment = formatByTimeZone(taskDates.start, null, true)

					if(startMoment.isBefore(earliestDate)){
						earliestDate = startMoment
					}
				}

				if(taskDates.end){
					const endMoment = formatByTimeZone(taskDates.end, null, true)

					if(endMoment.isAfter(latestDate)){
						latestDate = endMoment
					}
				}
			})
		}
		
		const dates = this.getCurrentDates()
		const earliestCurrentDate = moment(dates.start)
		const latestCurrentDate = moment(dates.end)

		canGoBack = earliestDate.isBefore(earliestCurrentDate)
		canGoForward = latestDate.isAfter(latestCurrentDate)

		return {
			back: canGoBack,
			forward: canGoForward
		}
	}

	setDataTypeIndex = dataTypeIndex => {
		this.setState({
			dataTypeIndex
		})
	}

	getEmptyCopy = _ => {
		const {
			userData
		} = this.props

		const {
			dataTypeIndex,
			pageIndex
		} = this.state

		let title = ''
		let body = ''

		if(!dataTypeIndex){
			if(pageIndex > -1){
				title = `Nothing to see here.`
				body = `${userData.first_name} has no time tracked for this period.`
			}else{
				title = `This date is in the future.`
				body = `Swap over to 'Assigned' to see what's upcoming.`
			}
		}else{
			title = `Nothing to see here.`
			body = `${userData.first_name} has no assigned timing for this period.`
		}

		return {
			title,
			body
		}
	}

	render() {
		const {
			allProjects,
			userData,
			loading
		} = this.props

		const {
			pageIndex,
			paginateType,
			dataTypeIndex
		} = this.state

		const sessionData = this.getPaginatedSessionData()

		const doughnutData = this.generateDoughnutData(sessionData)

		let legendData = []

		forIn(sessionData, (projectData, projectId) => {
			const project = allProjects[projectId]

			const largestNumber = (doughnutData.totalTracked > doughnutData.totalWorked) ? doughnutData.totalTracked : doughnutData.totalWorked

			const projectPercent = Math.round((projectData.hours/largestNumber) * 100)

			legendData.push({
				name: project ? project.name : '(Deleted project)',
				percent: projectPercent,
				seconds: projectData.seconds
			})
		})

		legendData = doSort(legendData, 'number', 'percent', true)

		const data = {
			datasets: [doughnutData.chartData],
			labels: [doughnutData.labelData]
		}

		const dates = this.getCurrentDates()

		const canChange = this.canChange()

		const dataTypes = ['Tracked','Assigned']

		return (
			<div className="widget box single-person-hours-pie">
				<h3 className="widget-title-tabs">
					{ dataTypes.map((dataType, index) => (
						<button 
							key={dataType} 
							className={dataTypeIndex === index ? 'active' : null}
							onClick={_ => {
								this.setDataTypeIndex(index)
							}}
						>
							{ dataType }
						</button>
					))}
				</h3>
				<Toggle 
					toggleState={paginateType == 'month'} 
					toggleChangeCallback={this.toggleState} 
					toggleOptions={this.toggleOptions} 
				/>
				<WeekNav
					changeDay={this.changeDay}
					canChange={canChange}
					pageIndex={pageIndex}
					paginateType={paginateType}
					dates={dates}
				/>
				<DoughnutChart 
					isDataFake={this.isDataFake}
					meta={doughnutData}
					data={data}
					thisUser={userData}
					legendData={legendData}
					showLegend={true}
					loading={loading}
					emptyCopy={this.getEmptyCopy()}
				/>
			</div>
		)
	}
}